// extracted by mini-css-extract-plugin
module.exports = {"userProfileFooterMenuWrapper":"styles_userProfileFooterMenuWrapper__11CpW","userProfileFooterMenu":"styles_userProfileFooterMenu__4lq_u"};